module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'form'
    ],

    config: {
        resourceConnected: false,
    },

    methods: {
        dataDealer(){
            let modal
            this.parent(p => modal = p)
            if(!modal) return;

            const decisionScope = (modal.model || {}).decisionScope || {}
            const promptAvailability = decisionScope.promptAvailability || {}

            const promptAvailabilitySummary = {
                ignore: promptAvailability.ignore || 0,
                none: promptAvailability.none || 0,
                single: (promptAvailability.viaProduct || 0) + (promptAvailability.viaSingleCategory || 0),
                multiple: promptAvailability.viaMultipleCategories || 0,
            }

            for(const field of this.model.fields || []){
                const {fieldCode} = field || {}
                const nrOfElements = promptAvailabilitySummary[fieldCode]
                if(nrOfElements !== undefined){
                    if(nrOfElements == 0 || fieldCode === 'ignore'){
                        field.config.disabled = true
                    }

                    // set labels
                    for(const [langCode, lang] of Object.entries(field.lang || {})){
                        lang.label = translationManager.getTranslator(langCode)(`prompt.availabilitySummaryForm.fields.${fieldCode}`, {nrOfElements})
                    }
                }
            }
        }
    },

    hooks: {
        async onDecision($element, options){
            let modal
            switch(options.decisionComponent.componentClass) {
                case 'base_modal_modal':
                case 'templates_modal_modal':
                    modal = options.decisionComponent
                    break
            }

            if(!modal){
                console.error('MISSING MODAL')
                return
            }

            if(options.decisionType !== 'decisionComponent'){
                return modal.hide()
            }

            const resourceData = {}
            this.replaceResourceAttributes(resourceData, this.resourceData, this.model.dirtyFields)
            await this.decideClosest(((resourceData || {}).data || {}).attributes || {})
            await modal.hide()
        }
    },
}
